import { render, staticRenderFns } from "./LiveChart.vue?vue&type=template&id=2825ef4f&scoped=true"
import script from "./LiveChart.vue?vue&type=script&lang=js"
export * from "./LiveChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825ef4f",
  null
  
)

export default component.exports